import React, { Component } from 'react'
import { Table, Empty, Card, Spin } from '@arco-design/web-react'
import Emptydata_img from 'asserts/Emptydata_img.svg'
import { getbalance } from 'api/apis'
import './index.scss'
// 封装组件
class Paymentdetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loadingbody: true,
      data: [],
      pagination: {
        sizeCanChange: false,
        showTotal: true,
        total: 0,
        pageSize: 10,
        current: 1,
        pageSizeChangeResetCurrent: true,
        showJumper: false
      },
      loading: false,
      no_data: false,
      keyword: '',
      checkbox: false,
      selectedRowKeys: [],
      type: 'checkbox',
      checkAll: false,
      indeterminate: false,
      SelectcheckAll: false,
      columns: [
        {
          title: '时间',
          dataIndex: 'created_at',
          align: 'center',
          headerCellStyle: {
            textAlign: 'center',
            height: 68
          },
          render: (col) => <span className="payment-details__cell-main">{col}</span>
        },
        {
          title: '变动账户',
          dataIndex: 'use_type',
          align: 'center',
          headerCellStyle: {
            textAlign: 'center'
          },
          render: (_, record) => (
            <div className="payment-details__cell">
              <span className="payment-details__account-tag">
                {this.getAccountLabel(record)}
              </span>
            </div>
          )
        },
        {
          title: '交易说明',
          dataIndex: 'bak',
          align: 'center',
          headerCellStyle: {
            textAlign: 'center'
          },
          render: (_, record) => (
            <div className="payment-details__cell">
              <div className="payment-details__cell-main">
                {this.getTransactionDescription(record)}
              </div>
            </div>
          )
        },
        {
          title: '变动金额',
          dataIndex: 'type',
          align: 'center',
          headerCellStyle: {
            textAlign: 'center'
          },
          render: (_, record) => {
            const displayAmount = this.getDisplayAmount(record)
            const amountClassName =
              record.type === 'IN'
                ? 'payment-details__amount payment-details__amount--in'
                : 'payment-details__amount payment-details__amount--out'

            return (
              <div className="payment-details__cell">
                <span className={amountClassName}>
                  {record.type === 'IN' ? '+' : '-'}
                  {this.formatAmount(displayAmount)}
                </span>
                {this.getAmountDetail(record) ? (
                  <div className="payment-details__cell-sub">
                    {this.getAmountDetail(record)}
                  </div>
                ) : null}
              </div>
            )
          }
        },
        {
          title: '变动后余额',
          dataIndex: 'balance',
          align: 'center',
          headerCellStyle: {
            textAlign: 'center'
          },
          render: (_, record) => (
            <div className="payment-details__cell">
              <div className="payment-details__cell-main">
                {this.getBalanceAfterText(record)}
              </div>
            </div>
          )
        }
      ]
    }
  }

  formatAmount(value) {
    return Number(value || 0).toFixed(2)
  }

  getRechargeChange(record) {
    const balance = Number(record.balance || 0)
    const balanceBefore = Number(record.balance_before || 0)
    return Math.abs(balance - balanceBefore)
  }

  getGiftChange(record) {
    return Number(record.gift_amount || 0)
  }

  hasRechargeChange(record) {
    const balance = Number(record.balance || 0)
    const balanceBefore = Number(record.balance_before || 0)
    return Math.abs(balance - balanceBefore) > 0
  }

  hasGiftChange(record) {
    return Number(record.gift_amount || 0) > 0
  }

  getAccountLabel(record) {
    const hasRechargeChange = this.hasRechargeChange(record)
    const hasGiftChange = this.hasGiftChange(record)

    if (hasRechargeChange && hasGiftChange) {
      return '充值金额 + 赠送金额'
    }
    if (hasRechargeChange) {
      return '充值金额'
    }
    if (hasGiftChange) {
      return '赠送金额'
    }
    return record.use_type || '-'
  }

  getTransactionDescription(record) {
    const hasRechargeChange = this.hasRechargeChange(record)
    const hasGiftChange = this.hasGiftChange(record)

    if (record.bak === '结算扣费') {
      return '结算扣费'
    }
    if (record.transaction_type === 'TOP_UP') {
      return hasGiftChange && !hasRechargeChange ? '赠送' : '充值'
    }
    if (record.transaction_type === 'CONSUME' || record.transaction_type === 'REFUND') {
      return '扣减'
    }
    if (hasGiftChange && !hasRechargeChange) {
      return '赠送'
    }
    if (hasRechargeChange) {
      return record.type === 'IN' ? '充值' : '扣减'
    }
    return record.bak || '-'
  }

  getDisplayAmount(record) {
    return this.getRechargeChange(record) + this.getGiftChange(record)
  }

  getAmountDetail(record) {
    const rechargeChange = this.getRechargeChange(record)
    const giftChange = this.getGiftChange(record)

    if (record.type === 'OUT' && rechargeChange > 0 && giftChange > 0) {
      return `其中赠送 ${this.formatAmount(giftChange)}`
    }
    return ''
  }

  formatSignedAmount(type, value) {
    const sign = type === 'IN' ? '+' : '-'
    return `${sign}${this.formatAmount(value)}`
  }

  getBalanceAfterText(record) {
    const totalBalance =
      Number(record.balance || 0) + Number(record.gift_balance || 0)
    return this.formatAmount(totalBalance)
  }

  componentDidMount() {
    this.getbalance()
  }
  UNSAFE_componentDidUpdate() {}
  getbalance() {
    let page = {
      per_page: this.state.pagination.pageSize,
      page: this.state.pagination.current,
      type: 'list'
    }
    this.setState({
      loading: true
    })
    getbalance(page).then((res) => {
      if (res.code === 200) {
        let list = res.data
        let pagination = {
          ...this.state.pagination,
          total: list.all_count
        }
        this.setState({
          pagination: pagination,
          data: list.data || [],
          loading: false,
          loadingbody: false,
          no_data: list.all_count > 0 ? false : true
        })
      } else {
        this.setState({
          loading: false,
          loadingbody: false,
          no_data: true
        })
      }
    })
  }
  onChangeTable(pagination) {
    const { current, pageSize } = pagination
    let setPagination = {
      ...this.state.pagination,
      current,
      pageSize
    }
    this.setState({
      loading: true,
      pagination: setPagination
    }, () => this.getbalance())
  }
  render() {
    const { loadingbody, loading, columns, data, pagination, no_data } =
      this.state
    return (
      <div className="payment-details">
        <div className="Header-init">
          <div className="Header-title">收支流水</div>
        </div>
        {loadingbody ? (
          <Spin loading={loadingbody} dot className="loadingbody"></Spin>
        ) : (
          <Card
            bordered={false}
            hoverable
            style={{ marginBottom: 20, borderRadius: 20 }}
            className="Table-card"
          >
            <Table
              style={{ marginTop: 10 }}
              virtualized
              noDataElement={
                <Empty imgSrc={Emptydata_img} description={'暂无收支记录'} />
              }
              no_data={no_data}
              border={{ wrapper: false, cell: false }}
              loading={loading}
              columns={columns}
              data={data}
              pagination={pagination.total === 0 ? false : pagination}
              onChange={this.onChangeTable.bind(this)}
              renderPagination={(paginationNode) => (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: 10
                  }}
                >
                  {paginationNode}
                </div>
              )}
              rowKey="id"
            />
          </Card>
        )}
      </div>
    )
  }
}
export default Paymentdetails
